import React, { useState } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { map, omit } from 'lodash';

import Checkbox from '~/commons/components/Checkbox.jsx';
import ListResource from './ListResource.jsx';
import BtnDayRangePicker from '../btns/BtnDayRangePicker.jsx';

import { env } from '../../config';

const ListAssignments = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const lang = language === 'en' ? 'en' : 'zhhk';

  const [dateRange, setDateRange] = useState(null);
  const [lv, setLv] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const subjectList = env.school?.stage === 'p'
    ? omit(env.allSubjects, [
      'chineseHistory',
      'lifeSociety',
      'csd',
      'history',
    ])
    : omit(env.allSubjects, ['generalStudies', 'humanities', 'sciences']);

  const setCheckboxState = (value, state, setState) => {
    if (state.find((x) => x === value)) {
      setState([...state].filter((y) => y !== value));
    } else {
      setState([...state, value]);
    }
  };

  let filter = {};
  // Don't automatically filter by school stage - let users see all assignments
  // if (env.school) filter.stage = env.school.stage;
  if (lv) filter.lv = lv;
  if (subjects.length > 0) filter.subjects = subjects;
  if (dateRange) filter = { ...filter, ...dateRange };

  return (
    <>
      <div
        className="col-10 rounded my-2 py-2"
        style={{ backgroundColor: '#FFF' }}
      >
        <div className="row my-2">
          <div className="col-auto" style={{ width: '110px' }}>
            {t('Group')}
          </div>
          <div className="col">
            {(env.school?.stage === 'p'
              ? ['y3', 'y4', 'y5', 'y6']
              : ['y7', 'y8', 'y9', 's2']
            ).map((v, i) => (
              <Checkbox
                key={i}
                className="text-secondary"
                onChange={() => setCheckboxState(v, lv, setLv)}
                value={lv.includes(v)}
              >
                <span className="ml-2 mr-3 text-body">
                  {env.lvs[v]?.[lang] || ''}
                </span>
              </Checkbox>
            ))}
          </div>
        </div>
        <div className="row my-2">
          <div className="col-auto" style={{ width: '110px' }}>
            {t('Subjects')}
          </div>
          <div className="col">
            {map(subjectList, (s, i) => (
              <Checkbox
                key={i}
                className="text-secondary"
                value={subjects.includes(i)}
                onChange={() => setCheckboxState(i, subjects, setSubjects)}
              >
                <span className="ml-2 mr-3 text-body">{s[lang]}</span>
              </Checkbox>
            ))}
          </div>
        </div>
      </div>

      <ListResource
        {...{
          searchable: true,
          api: '/api/quiz/assignments',
          sort: { date: -1 },
          filter,
          actions: {
            create: false,
            remove: false,
          },
          cols: [
            {
              key: 'date',
              sortable: true,
              getter: (v) => moment(v).format('YYYY-MM-DD'),
            },
            {
              key: 'lv',
              children: 'Group',
              getter: (v) => env.lvs[v]?.[lang] || '',
            },
            { key: 'article.title', sortable: true },
            { key: 'article.tags', getter: (v) => (v || []).join(', ') },
            {
              key: 'article.subjects',
              getter: (v) => (v || [])
                .map((s) => (env.subjects[s] ? env.subjects[s][lang] : ''))
                .join(', '),
            },
          ],
        }}
      >
        {() => (
          <>
            <BtnDayRangePicker
              className="mr-2"
              value={dateRange}
              onChange={setDateRange}
              placeholder={t('Assignment Date')}
            />
          </>
        )}
      </ListResource>
    </>
  );
};
export default ListAssignments;
